import api from "./api.js";

export default class FaqApi {
  static async getList(data) {
    return await api.get(`api/faq`, data);
  }

  static async getDetail(id) {
    return await api.get(`api/faq/${id}`);
  }
}
